// extracted by mini-css-extract-plugin
export var benefitsWapper = "benefits-module--benefitsWapper--c0ef2";
export var benefits_main_title = "benefits-module--benefits_main_title--359e5";
export var cardList = "benefits-module--cardList--f3868";
export var cardTitle = "benefits-module--cardTitle--ec5c0";
export var cardWapper = "benefits-module--cardWapper--9e3de";